import moment from 'moment'
export default {

  methods: {

    set_Timeline() {

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let cutoff = moment(moment(this.timeline.cutoff).format('YYYY-MM-DD 23:59:59')).toDate()

      // Timeline
      this.timeline.week = [],
      this.timeline.month = [],
      this.timeline.year = [],
      this.timeline.scale = null,
      
      this.timeline.startDate = this.gmx_getTimePeriod(cutoff, 'wednesday', this.toolBar.timePeriod.find(f=> f.checked).month).first
      this.timeline.endDate = this.gmx_getTimePeriod(cutoff, 'wednesday', 1).last

      this.gmx_TimelineValues(this.timeline)

      // Work Order --------------------------------
      this.rawData.forEach(d=> {
        if(!d.PLAN) {
          d.PLAN = moment(cutoff).add(3, 'weeks').format('YYYY-MM-DD')
          d.TARGET = moment(cutoff).add(3, 'weeks').format('YYYY-MM-DD')
        }

        if(d.LAUNCH) d.TARGET = d.LAUNCH

        if(d.PLAN > this.timeline.startDate || d.STATUS == 'Planned') {
          d.sDate = this.gmx_setTimelineCDate(d.PLAN).sDate
          d.eDate = this.gmx_setTimelineCDate(d.TARGET).eDate
          d.thisWeek = ''
          d.planned = ''

          let st = this.status.find(f=> f.name == d.STATUS) 
          d.stroke = st.stroke
          d.color = st.color

          if(d.INCHARGE == 'paul.lee' || d.INCHARGE == 'jeyoung') {
            d.dept = 'Service'
          } else if(d.INCHARGE == 'seungwook.han') {
            d.dept = 'System'
          } else { d.dept = 'Developing' }

          if(cutoff.toISOString().slice(0, 10) == d.eDate.toISOString().slice(0, 10)) d.thisWeek = 'Y'
          if(cutoff.toISOString().slice(0, 10) < d.eDate.toISOString().slice(0, 10)) d.planned = 'Y'

          if(d.STATUS == 'Completed' || d.STATUS == 'Verified' || d.STATUS == 'Launched') d.PROG = 100
        }
      })
      this.rawData = this.rawData.filter(f=> f.PLAN > this.timeline.startDate)

      this.filterData() // -----> below
    },


    filterData() {

      // Department
      let arrDept = [ ...new Set(this.toolBar.department.filter(f=> f.checked).map(d => d.value)) ]
      this.dataSet = this.rawData.filter(d => arrDept.includes(d.dept))

      // Set Navigation
      this.navigation = [
        ...new Set(this.dataSet.map(item => `${item.PHASE}|${item.GROUP}|${item.ITEM}`))
      ].map(key => {
        const [PHASE, GROUP, ITEM] = key.split('|')
        return { PHASE, GROUP, ITEM }
      })
      
      this.navigation.forEach((d,i)=> {

        let getMenu = this.dataSet.findLast(f=> f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM)
        d.idx = i

        d.rev = getMenu.REV
        d.countOutstand = this.dataSet.filter(f=> f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM && (f.thisWeek == 'Y' || f.planned == 'Y')).length
        d.countThisweek = this.dataSet.filter(f=> f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM && f.thisWeek == 'Y').length
        d.thisWeek = this.dataSet.filter(f=> f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM && f.thisWeek == 'Y').length
        d.status = d.countOutstand > 0 ? getMenu.STATUS : ''
        d.tColor = this.status.find(f=> f.name == d.status) ? this.status.find(f=> f.name == d.status).tColor : ''

      })

      // Status Filtering
      if(this.toolBar.filtering[1].checked) this.navigation = this.navigation.filter(f=> f.countOutstand > 0)
      if(this.toolBar.filtering[2].checked) this.navigation = this.navigation.filter(f=> f.countThisweek > 0)

      this.tblHeight = (this.navigation.length+2) * 25
    },

  }
}